import companyService from "../../../services/company.service"

export default {
    create({ dispatch }, params) {
        return companyService.createNewCompany(params)
            .then(response => {
                dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
            })
            .catch(error =>{
                if(Object.values(error.errors).length > 0){
                    dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    update({commit, dispatch}, data){
        return companyService.updateCompany(data)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
            })
            .catch(error => {
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    fetchList({ commit, dispatch }, payload) {
        return companyService.getCompanyList(payload)
            .then(response => {
                commit('SET_COMPANIES_LIST', response.data.data)
                commit('SET_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
                return Promise.resolve(response.data.data)
            })
            .catch(error =>{
                if(Object.values(error.errors).length > 0){
                    dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    fetchCompany({dispatch}, id) {
        return companyService.getCompany(id)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    showAdmin({commit, dispatch}, { companyId, userId}) {
        return companyService.getCompanyAdmin(companyId, userId)
            .then(response => {
                commit('SET_ADMIN', response.data.data)
                return Promise.resolve(response.data)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    fetchAdmin({commit, dispatch}, companyId) {
        return companyService.getCompanyAdminList(companyId)
            .then(response => {
                commit('SET_ADMIN', response.data)
                // commit('SET_ADMIN_INFO_DB', {totalPage: response.data.last_page, totalRow: response.data.total})
                return Promise.resolve(response.data)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    updateAdmin({dispatch}, { companyId, userId, payload}) {
        return companyService.updateCompanyAdmin(companyId, userId, payload)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data || true)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    createAdmin({dispatch}, { companyId, payload}) {
        return companyService.createCompanyAdmin(companyId, payload)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data || true)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    deleteAdmin({dispatch}, { companyId, userId}) {
        return companyService.deleteCompanyAdmin(companyId, userId)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data || true)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
    deleteCompany({dispatch}, id) {
        return companyService.deleteCompany(id)
            .then(response => {
                dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0]:response.message, { root: true })
                return Promise.resolve(response.data)
            })
            .catch(error =>{
                if(typeof error.errors == 'object'){
                    if(Object.values(error.errors).length > 0){
                        dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                    }
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },    fetchUsageReport({ commit, dispatch }, payload) {
        return companyService.fetchUsageReport(payload)
            .then(response => {
                return Promise.resolve(response.data)
            })
            .catch(error =>{
                if(Object.values(error.errors).length > 0){
                    dispatch("alertError",Object.values(error.errors)[0][0], { root: true });
                }
                else dispatch("alertError",typeof error.message == 'object' ? error.message[0]:error.message, { root: true });
            })
    },
}
